// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2X8n4","actions":"GroupTable_actions__3ONBo","deleteModalFooter":"GroupTable_deleteModalFooter__1s9_Y"};